module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/referrer'));
  PluginManager.registerAudienceMatcher('referrer', require('./matchers/referrer'));
};
